import React from 'react';
import DataContainer from 'Components/UI/DataContainer';
import { RoadmapExecutiveSummaryContentForDeliverable } from './RoadmapExecutiveSummaryForDeliverable/RoadmapExecutiveSummaryContentForDeliverable';
import { RoadmapExecutiveSummarySkeleton } from './RoadmapExecutiveSummarySkeleton';

const RoadmapExecutiveSummaryContainerForDeliverable = ({ resource }) => {
  return (
    <DataContainer
      component={RoadmapExecutiveSummaryContentForDeliverable}
      componentProps={{
        resource,
        showHeaderAndFooter: false,
      }}
      skeleton={RoadmapExecutiveSummarySkeleton}
    />
  );
};

export default RoadmapExecutiveSummaryContainerForDeliverable;
